const eventLogger = (event) => {
  if (event.persisted) {
    location.reload();
  }
};

export const loadPageShowEvent = {
    loadEvent() {window.addEventListener("pageshow", eventLogger)},
    removeEvent() {window.removeEventListener("pageshow", eventLogger)}
}
